// extracted by mini-css-extract-plugin
module.exports = {"container":"productCard_container__2Zsa0","textSave":"productCard_textSave__2I1LY","list":"productCard_list__2cnN2","button":"productCard_button__262rH","contentInputNumber":"productCard_contentInputNumber__3yxqm","contentToggle":"productCard_contentToggle__1FO94","openInMobile":"productCard_openInMobile___iyJ_","arrow":"productCard_arrow__D6gHX","arrowReverse":"productCard_arrowReverse__2dilB","mobileOnly":"productCard_mobileOnly__1rYDA"};
    if(module.hot) {
      // 1790670317044
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  